import { dialog, DialogSize, UrlDialogInfo, app } from "@microsoft/teams-js";
import { TFunction } from "i18next";
import * as React from 'react';
import { withTranslation, WithTranslation } from "react-i18next";
import { connect } from "react-redux";
import { verifyTemplatesAccess } from '../../apis/messageListApi'
import { getDraftMessagesList, getScheduledMessagesList } from "../../actions";
import { getBaseUrl } from "../../configVariables";
import TabContainer from '../TabContainer/tabContainer';
import Templates from '../Templates/templates';
import CommsCalendar from "../Calendar/calendar";
import InsightsDashboard from "../Insights/insightsDashboard";
import './communicatorContainer.scss'
import NewTemplate from "../NewTemplate/newTemplate";
import { Button, TabList, Tab, SelectTabEvent, SelectTabData } from "@fluentui/react-components"
import { Add24Filled } from '@fluentui/react-icons';

interface IHomePageState {
  showMessages: boolean;
  showTemplates: boolean;
  newTemplate: boolean;
  showCalendar: boolean;
  showInsights: boolean;
  restrictTemplateTab: boolean;
}

interface IHomePageProps extends WithTranslation {
  context: any;
  description: string;
  siteUrl: string;
  getDraftMessagesList?: any;
  getScheduledMessagesList?: any;
}

class HomePage extends React.Component<IHomePageProps, IHomePageState> {
  readonly localize: TFunction;
  private interval: any;
  constructor(props: any) {
    super(props);
    this.localize = this.props.t;
    this.state = {
      showMessages: false,
      showTemplates: false,
      newTemplate: false,
      showCalendar: false,
      showInsights: false,
      restrictTemplateTab: true,
    };
    this.escFunction = this.escFunction.bind(this);
  }

  public async componentDidMount() {
    await app.initialize();
    let restrictTemplateTab = true;
    try {
      await verifyTemplatesAccess()
      restrictTemplateTab = false;
    } catch {
    }

    this.setState({ showMessages: true, restrictTemplateTab: restrictTemplateTab });
    document.addEventListener("keydown", this.escFunction, false);
  }

  public componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
    clearInterval(this.interval);
  }

  public render(): JSX.Element {
    return (
      <div className="cc-container">
        <div className="cc-navigation">
          <div className="cc-nav-item cc-nav-title" >
            <h3>Company Communicator</h3>
          </div>
          <div className="cc-nav-item cc-nav-menu">
            <TabList defaultSelectedValue={'messages'} onTabSelect={this.onTabSelect}>
              <Tab value='messages'>Messages</Tab>
              {!!!this.state.restrictTemplateTab && <Tab value='templates'>Templates</Tab>}
              <Tab value='calendar'>Calendar</Tab>
              <Tab value='insights'>Insights</Tab>
            </TabList>
          </div>
          {!this.state.showTemplates && (
            <div className="cc-nav-item cc-nav-button">
              <Button icon={<Add24Filled />} onClick={this.onNewMessage} appearance='primary' >{this.localize("NewMessage")}</Button>
            </div>
          )}
          {this.state.showTemplates && (
            <div className="cc-nav-item cc-nav-button">
              <Button icon={<Add24Filled />} onClick={this.onNewTemplate} appearance='primary' >{this.localize("NewTemplate")}</Button>
            </div>
          )}
        </div>
        {this.state.showMessages && (
          <TabContainer />
        )}
        {this.state.newTemplate && (
          <NewTemplate onBackToList={this.onBackToMenu} />
        )}
        {(this.state.showTemplates && !this.state.newTemplate) && (
          <Templates />
        )}
        {this.state.showCalendar && (
          <CommsCalendar />
        )}
        {this.state.showInsights && (
          <InsightsDashboard />
        )}

      </div>
    );
  }

  private onTabSelect = (event: SelectTabEvent, data: SelectTabData) => {
    this.setState({
      showMessages: data.value === 'messages',
      showTemplates: data.value === 'templates',
      newTemplate: false,
      showCalendar: data.value === 'calendar',
      showInsights: data.value === 'insights',
    });
  }



  public onNewMessage = () => {
    const urlDialogInfo: UrlDialogInfo = {
      url: getBaseUrl() + "/newmessage?locale={locale}",
      title: this.localize("NewMessage"),
      size: {
        height: 600,
        width: 1000
      } as DialogSize,
      fallbackUrl: getBaseUrl() + "/newmessage?locale={locale}",
    }

    const submitHandler = (result: dialog.ISdkResponse) => {
      this.props.getDraftMessagesList().then(() => {
        return new Promise(resolve => setTimeout(resolve, 1000)).then(() => this.props.getScheduledMessagesList())
      })
    };

    dialog.url.open(urlDialogInfo, submitHandler);
  }

  public onNewTemplate = () => {
    this.setState({
      newTemplate: true,
    });
  }

  public onBackToMenu = () => {
    this.setState({
      newTemplate: false,
    });
  }

  private escFunction = (event: any) => {
    if (event.keyCode === 27 || (event.key === "Escape")) {
      dialog.url.submit();
    }
  }
}

const mapStateToProps = (state: any) => {
  return { messages: state.draftMessagesList };
}

const homePageWithTranslation = withTranslation()(HomePage);
export default connect(mapStateToProps, { getDraftMessagesList, getScheduledMessagesList })(homePageWithTranslation);